<template>
  <div>
    <div class="mailbox-title">
      <div>{{ $t("alarms.mailbox.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['nonCloudResources:mailbox:add_alert_rule']"
          @click="addOrUpdateHandle"
          >{{ $t("alarms.mailbox.addMailBoxAlarm") }}</Button
        >
        <add-or-update-mailbox-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-mailbox-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.common.alertRule')">
          <div class="mailbox-top">
            <mailbox-warning-search></mailbox-warning-search>
          </div>
          <table-mailbox-warning></table-mailbox-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import MailboxWarningSearch from "../mailbox/MailboxWarningSearch";
import TableMailboxWarning from "../mailbox/TableMailboxWarning";
import AddOrUpdateMailboxWarning from "../mailbox/AddOrUpdateMailboxWarning";

export default {
  name: "Mailbox",
  components: {
    MailboxWarningSearch,
    TableMailboxWarning,
    AddOrUpdateMailboxWarning
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.mailbox-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}

.mailbox-title > div:nth-child(1) {
  float: left;
}

.mailbox-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}

.mailbox-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/non_cloud_resources/mailbox/Mailbox.vue